import React, { useEffect, useState } from "react";

import { getFileFromS3WithPresigned, getFileContentType } from "../../../../../../../utils/helpers";
import "./COABuilderImage.css";

export default function COABuilderImage({ title, imagePath, handleBuilderFile }) {
  const [imageSrc, setImageSrc] = useState("");
  const loadImage = async () => {
    if (imagePath) {
      const name = imagePath.split("/").pop();
      const fileBlobObj = await getFileFromS3WithPresigned([imagePath], "private");
      const blob = fileBlobObj?.[imagePath];
      if (!blob) {
        return;
      }
      const previewURL = URL.createObjectURL(blob);
      setImageSrc(previewURL);
      const file = new File([blob], name, { type: getFileContentType({ name, type: blob.type }) });
      handleBuilderFile({ file, name, title });
    }
  };
  useEffect(() => {
    loadImage();
  }, []); // eslint-disable-line

  return (
    <div className="COABuilderImage__Container">
      <img
        alt="logo"
        src={imageSrc}
        className="COABuilderImage"
      />
    </div>
  );
}
